(function() {
    'use strict';
    var DialogsByTemplate = require('./modules/dialogs_by_template');
    const trackingUtils = require('od-modules/utils/tracking.utils');

    Odigeo.UIElements.showSessionExpiredErrorByTemplate = function() {
        var options = {
            dialogID: 'sessionExpireDialog',
            template: '.session_expire_dialog_tmpl',
            content: sessionExpiredErrorContent(Odigeo.UIElements.translations.errSessionExpiredCallUs),
            actions: ['back', 'retry'],
            dataTracking: {
                back: {action: 'back_end_errors', label: 'session_expiring_new_search'},
                retry: {action: 'back_end_errors', label: 'session_expiring_same_search'},
            },
        };

        new DialogsByTemplate(options);
    };

    Odigeo.UIElements.Cobalt = {
        showBookingAlreadyDone: function() {
            const translations = Odigeo.UIElements.translations.alreadyConfirmed;
            translations.content = translations.desc;

            const buttonsConfiguration = [
                {
                    text: translations.button,
                    css: 'dialog_close_btn prisma-btn-default',
                },
            ];

            const options = {
                dialogID: 'errorCobaltUIDialog',
                template: '.errors_cobaltui',
                content: Object.assign(translations, {buttonsConfiguration}),
                bindableActions: {
                    dialogCloseButtonAction: {
                        selector: '.dialog_close_btn',
                        action: 'tap',
                        method: 'back',
                    },
                },
                actions: ['dialogCloseButtonAction'],
                customActionReaction: {},
                dataTracking: {},
            };

            new DialogsByTemplate(options);
        },
        showErrorDialogByTemplate: function(error) {
            let translations;
            let trackingPrefixLabel;

            switch (error) {
                case 0:
                    translations = Odigeo.UIElements.translations.err0;
                    trackingPrefixLabel = '0';
                    break;
                case 500:
                    translations = Odigeo.UIElements.translations.err500;
                    trackingPrefixLabel = 'server_down';
                    break;
                case 404:
                    translations = Odigeo.UIElements.translations.err404;
                    trackingPrefixLabel = '404';
                    break;
            }

            let buttonsConfiguration = [
                {
                    text: translations.button,
                    css: 'dialog_close_btn prisma-btn-default',
                },
            ];

            if (error === 404) {
                buttonsConfiguration = [];
            }

            const options = {
                dialogID: `${Odigeo.SessionScope.flowProduct}-popup-broken-flow`,
                template: '.errors_cobaltui',
                content: Object.assign(translations, {buttonsConfiguration}),
                bindableActions: {
                    dialogCloseButtonAction: {
                        selector: '.dialog_close_btn',
                        action: 'tap',
                        method: 'close',
                    },
                },
                actions: ['dialogCloseButtonAction', 'closeOnClickOutside'],
                customActionReaction: {
                    close: () => {
                        Odigeo.trigger('analytics:tracking', {
                            type: 'trackEvent',
                            data: {
                                action: 'back_end_errors',
                                label: trackingPrefixLabel + '_screen_button_error',
                            },
                        });
                        window.location.href = translations.link;
                    },
                },
                dataTracking: {},
            };

            new DialogsByTemplate(options);
        },
        showBrokenFlowErrorPopupByTemplate: function(reverseButtons = true) {
            const translations = Odigeo.UIElements.translations.errBrokenFlow;
            const isDynpack = Odigeo.Utils.isRequestApp('dp');

            const dialogCancelAction = () => {
                trackingUtils.trackEvent('request_errors', 'broken_flow_try_new_dates');
                Odigeo.UIElements.hideAllDialogs();
                Odigeo.Utils.goToApplicationHome(isDynpack);
            };
            const dialogRetryAction = () => {
                trackingUtils.trackEvent('request_errors', 'broken_flow_retry_search');
                Odigeo.trigger('frontend-shell:restore-render-error');
                Odigeo.trigger('sessionExpireDialog:repeatSearch', Odigeo.History.getPageNameFromFragment());
            };

            let buttonsConfiguration = [
                {
                    text: translations.buttons[0].title,
                    css: 'dialog_cancel_go_to_home_btn',
                },
                {
                    text: translations.buttons[1].title,
                    css: 'dialog_retry_btn',
                },
            ];

            if (reverseButtons) {
                buttonsConfiguration = buttonsConfiguration.reverse();
            }

            const options = {
                dialogID: `${Odigeo.SessionScope.flowProduct}-popup-broken-flow`,
                template: '.brokenflow_cobaltui',
                content: Object.assign(translations, {buttonsConfiguration}),
                bindableActions: {
                    cancelGoToHome: {
                        selector: '.dialog_cancel_go_to_home_btn',
                        action: 'tap',
                        method: 'cancelGoToHomeReaction',
                    },
                    repeatSearch: {
                        selector: '.dialog_retry_btn',
                        action: 'tap',
                        method: 'repeatSearchReaction',
                    },
                },
                actions: ['cancelGoToHome', 'repeatSearch'],
                customActionReaction: {
                    cancelGoToHomeReaction: dialogCancelAction,
                    repeatSearchReaction: dialogRetryAction,
                },
                dataTracking: {},
            };

            new DialogsByTemplate(options);
        },
        showSelectionErrorPopupByTemplate: function() {
            const isMobile = Odigeo.SessionScope.flow === 'mobile';
            const translations = Odigeo.UIElements.translations.errSelection;

            const dialogBackToResultsAction = () => {
                trackingUtils.trackEvent('request_errors', 'broken_flow_back-results');
                Odigeo.trigger('frontend-shell:restore-render-error');
                const path = Odigeo.History.getPageNameFromFragment();
                path.includes('checkout_flight_summary_results')
                    ? Odigeo.Router.navigate('results')
                    : Odigeo.trigger('sessionExpireDialog:repeatSearch', path);
            };

            const boxHorizontalMargin = isMobile
                ? 'odf-space-inner-left-m odf-space-inner-right-m'
                : 'odf-space-inner-left-5xl odf-space-inner-right-5xl';

            const options = {
                dialogID: `${Odigeo.SessionScope.flowProduct}-popup-selection-error`,
                template: '.error_selection_dialog',
                content: Object.assign(translations, {boxHorizontalMargin}),
                bindableActions: {
                    backToSearch: {
                        selector: '.dialog_back_to_search_btn',
                        action: 'tap',
                        method: 'backToResultsAction',
                    },
                },
                actions: ['backToSearch'],
                customActionReaction: {
                    backToResultsAction: dialogBackToResultsAction,
                },
                dataTracking: {},
            };

            new DialogsByTemplate(options);
        },
        showAccommodationPBBrokenFlowErrorPopUpByTemplate: function() {
            const translations = Odigeo.UIElements.translations.errBrokenFlowAccommodationPostBooking;

            const buttonAction = () => {
                Odigeo.UIElements.hideAllDialogs();
                Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();
                Odigeo.Session.set('comesFromError', true);
                Odigeo.trigger('frontend-shell:restore-render-error');
                if (Odigeo.History.getPageNameFromFragment() === 'detailsloading') {
                    Odigeo.Router.navigate('xsellproductselection');
                } else {
                    Odigeo.Utils.launchAccommodationPBSearch();
                }
            };

            const buttonsConfiguration = [
                {
                    text: translations.button.title,
                    css: 'dialog_retry_btn prisma-btn-default',
                },
            ];

            const options = {
                dialogID: 'AccommodationPBBrokenFlowDialog',
                template: '.brokenflow_cobaltui',
                content: Object.assign(translations, {buttonsConfiguration}),
                bindableActions: {
                    retrySearch: {
                        selector: '.dialog_retry_btn',
                        action: 'tap',
                        method: 'retryPBAccommodationSearch',
                    },
                },
                actions: ['retrySearch'],
                customActionReaction: {
                    retryPBAccommodationSearch: buttonAction,
                },
                dataTracking: {},
            };

            new DialogsByTemplate(options);
        },
        showSearchExpiredErrorByTemplate: function() {
            const searchExpiredErrorContent = function(translations) {
                return {
                    header: translations.header,
                    content: translations.content,
                    cancelGoToHome: translations.buttons[0].title,
                    repeatSearch: translations.buttons[1].title,
                };
            };

            const cancelGoToHomeFunction = () => {
                Odigeo.Utils.goToApplicationHome(Odigeo.Utils.isRequestApp('dp'));
            };
            const repeatSearchFunction = () => {
                Odigeo.UIElements.hideAllDialogs();
                Odigeo.trigger('sessionExpireDialog:repeatSearch');
            };

            let options = {
                dialogID: 'showSearchExpiredErrorByTemplate',
                template: '.brokenflow_cobaltui',
                content: searchExpiredErrorContent(Odigeo.UIElements.translations.errSearchExpired),
                bindableActions: {
                    cancelGoToHome: {
                        selector: '.dialog_cancel_go_to_home_btn',
                        action: 'tap',
                        method: 'cancelGoToHome',
                    },
                    repeatSearch: {
                        selector: '.dialog_retry_btn',
                        action: 'tap',
                        method: 'repeatSearch',
                    },
                },
                actions: ['cancelGoToHome', 'repeatSearch'],
                customActionReaction: {
                    cancelGoToHome: cancelGoToHomeFunction,
                    repeatSearch: repeatSearchFunction,
                },
                dataTracking: {},
            };

            new DialogsByTemplate(options);
        },
    };

    Odigeo.UIElements.showDynpackSessionExpiredError = function(options) {
        const defaultOptions = {
            dialogID: `${Odigeo.SessionScope.flowProduct}-popup-session-expired`,
            template: '.session_expire_dialog_tmpl',
            content: Object.assign(sessionExpiredErrorContent(Odigeo.UIElements.translations.errSessionExpiredCallUs),
                {retry: Odigeo.UIElements.translations.errSessionExpiredCallUs.buttons[2].title}
            ),
            actions: ['back', 'retryDynpackDeeplink'],
            dataTracking: {
                back: {action: 'back_end_errors', label: 'session_expiring_new_search'},
                retryDynpackDeeplink: {action: 'back_end_errors', label: 'session_expiring_same_search'},
            },
        };

        new DialogsByTemplate(Object.assign({}, defaultOptions, options));
    };

    Odigeo.UIElements.showSessionExpiredErrorAccommodationPB = function() {
        var content = sessionExpiredErrorContent(Odigeo.UIElements.translations.errSessionExpiredCallUs);
        var options = {
            dialogID: 'sessionExpireDialog',
            template: '.session_expire_dialog_tmpl',
            content: Odigeo._.omit(content, 'back'),
            actions: ['retryAccommodationPB'],
            dataTracking: {
                retryAccommodationPB: {action: 'back_end_errors', label: 'session_expiring_same_search'},
            },
        };

        new DialogsByTemplate(options);
    };

    Odigeo.UIElements.showDynpackSessionExpiredErrorReturningVisitors = function() {
        const content = sessionExpiredErrorReturningVisitorsContent(Odigeo.UIElements.translations.errSessionExpiredReturningVisitors);
        const options = {
            dialogID: `${Odigeo.SessionScope.flowProduct}-popup-session-expired`,
            template: '.session_expire_returning_visitors_tmpl',
            content: Odigeo._.omit(content, 'back'),
            actions: ['back', 'retryReturningVisitor'],
            dataTracking: {},
        };
        new DialogsByTemplate(options);
    };

    Odigeo.UIElements.showSessionAboutToExpireAlertByTemplate = function(params) {
        var config = sessionAboutToExpireAlertConfig(Odigeo.UIElements.translations.alertSessionAboutToExpire);
        var options = {
            dialogID: 'sessionAboutToExpireAlert',
            template: config.template,
            content: sessionAboutToExpireAlertContent(config),
            removeClass: Odigeo._.get(params, 'removeClass'),
            actions: config.actions || ['close', 'closeOnClickOutside'],
            bindableActions: config.bindableActions,
            dataTracking: {
                close: {action: 'back_end_errors'},
                ...{...config.dataTracking || {}},
            },
        };
        new DialogsByTemplate(options);
    };

    Odigeo.UIElements.loadingMyTripsDialogByTemplate = function() {
        var config = Odigeo.UIElements.translations.loadingMyTripsDialog;
        var options = {
            dialogID: 'loadingMyTripsDialog',
            template: '.loadingMyTripsDialog',
            content: config.content,
            actions: [],
            dataTracking: {
                show: {action: 'find_bookings', label: 'access_my_trips_automatic_loading'},
            },
        };

        return new DialogsByTemplate(options);
    };

    Odigeo.UIElements.loadingMyTripsErrorDialogByTemplate = function() {
        var config = Odigeo.UIElements.translations.loadingMyTripsErrorDialog;
        var options = {
            dialogID: 'loadingMyTripsErrorDialog',
            template: '.loadingMyTripsErrorDialog',
            content: config.content,
            actions: ['close'],
            dataTracking: {
                show: {action: 'find_booking_error', label: 'access_my_trips_automatic_error'},
            },
        };

        return new DialogsByTemplate(options);
    };

    Odigeo.UIElements.createGenericDialogByTemplate = function(opts) {
        let options = {
            dialogID: 'genericIconTextDialog',
            template: '.genericIconTextDialog',
            content: opts.data,
            actions: ['close', ...opts.actions],
            dataTracking: opts.tracking,
        };
        return new DialogsByTemplate(options);
    };

    var sessionExpiredErrorContent = function(translations) {
        var data = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
        var dateFormat = translations.dateFormat;
        var response = {};
        if (!Odigeo._.isUndefined(data) && data && data.searchSegments && data.searchSegments.length) {
            var isMultiTrip = data.type === 'multipleTrip';
            var firstFlight = data.searchSegments[0];
            var lastFlight = data.searchSegments[data.searchSegments.length - 1];
            var paxSelected = {
                adults: {number: Number(data.numAdults), key: translations.adults},
                children: {number: Number(data.numChildren), key: translations.children},
                infants: {number: Number(data.numInfants), key: translations.infants},
            };
            var header = isMultiTrip ? translations.headerMulti : Odigeo.Utils.replaceCmsKeyArgs(translations.header, firstFlight.destination.city);
            var title = data.type === 'oneWayTrip' ? '' : convertDate(firstFlight.dateStr, dateFormat) + ' - ';
            title += convertDate(lastFlight.dateStr, dateFormat) + '<br/>' + getPaxString(paxSelected, translations);
            var flightInfo = '';
            if (isMultiTrip) {
                Odigeo._.each(data.searchSegments, function(segment) {
                    flightInfo += '<div class="odf-text-md">' +
                        '<span class="odf-strong">' + segment.departure.city + '</span> - ' +
                        '<span class="odf-strong">' +segment.destination.city + '</span> - ' +
                        convertDate(segment.dateStr, dateFormat) + '</div>';
                });
            }
            flightInfo = Odigeo._.isEmpty(flightInfo) ? '' : '<div class="od-expire-call-us-flights">' + flightInfo + '</div>';
            response = {
                header: header,
                title: title,
                flightInfo: flightInfo,
                accommodationInfo: getSeparateStay(data, translations),
                footer: translations.footer,
                footerInfo: translations.subtext,
                footerCharges: getPhoneInfo(translations),
                back: translations.buttons[0].title,
                retry: translations.buttons[1].title,
            };
        }
        return Object.assign({
            header: translations.headerMulti,
            footer: translations.footer,
            footerInfo: translations.subtext,
            footerCharges: getPhoneInfo(translations),
            back: translations.buttons[0].title,
            retry: translations.buttons[1].title,
        }, response);
    };

    var sessionExpiredErrorReturningVisitorsContent = function(translations) {
        const data = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
        const dateFormat = translations.dateFormat;
        let response = {};
        let flightInfo = '';
        if (!Odigeo._.isUndefined(data) && data && data.searchSegments && data.searchSegments.length) {
            const isMultiTrip = data.type === 'multipleTrip';
            const firstFlight = data.searchSegments[0];
            const lastFlight = data.searchSegments[data.searchSegments.length - 1];
            const paxSelected = {
                adults: {number: Number(data.numAdults), key: translations.adults},
                children: {number: Number(data.numChildren), key: translations.children},
                infants: {number: Number(data.numInfants), key: translations.infants},
            };
            const dates = data.type === 'oneWayTrip' || isMultiTrip
                ? ''
                : `<div class="odf-space-inner-bottom-xs">
                <span>${convertDate(firstFlight.dateStr, dateFormat)}</span> <span>-</span>
                <span>${convertDate(lastFlight.dateStr, dateFormat)}</span>
                </div>`;
            if (isMultiTrip) {
                Odigeo._.each(data.searchSegments, function(segment) {
                    flightInfo +=
                        `<div>
                            <span class="odf-bold">${segment.departure.city}</span><span class="odf-bold"> ${translations.to} </span>
                            <span class="odf-bold">${segment.destination.city}</span> - ${convertDate(segment.dateStr, dateFormat)}
                        </div>`;
                });
            } else {
                flightInfo =
                    `<span class="odf-bold">${firstFlight.departure.city}</span>
                    <span class="odf-bold"> ${translations.to} </span>
                    <span class="odf-bold">${firstFlight.destination.city}</span>`;
            }
            flightInfo = Odigeo._.isEmpty(flightInfo) ? '' : flightInfo;
            response = {
                header: translations.header,
                subtitle: translations.subtitle,
                dates: dates,
                paxSelected: getPaxString(paxSelected, translations),
                flightInfo: flightInfo,
                accommodationInfo: getSeparateStay(data, translations),
                buttonNewSearch: translations.buttons.buttonNewSearch,
                buttonRecoverFlight: translations.buttons.buttonRecoverFlight,
                to: translations.to,
            };
        }
        return response;
    };

    const sessionAboutToExpireAlertConfig = function(translations) {
        let response = {
            template: '.session_about_to_expire_alert_old_tmpl',
            translations: pluralizeSteps(setSessionAboutToExpireAlertForFlexibility(translations.old)),
        };
        if (Odigeo.AB.isMessage10MinWarningMobile) {
            response = {
                template: '.session_about_to_expire_alert_old_tmpl',
                translations: setSessionAboutToExpire10MinWarningMobile(translations.old),
            };
        } else if (!isMobile() && Odigeo.AB.isNewWarningPopup) {
            response = {
                template: '.session_about_to_expire_alert_tmpl',
                translations: pluralizeSteps(translations.old),
            };
        } else if (Odigeo.Utils.isRequestApp('dp')) {
            response = {
                template: '.session_about_to_expire_alert_hurry',
                translations: pluralizeSteps(setSessionAboutToExpire10MinImprovements(translations.old)),
                actions: ['close'],
                dataTracking: {
                    close: {
                        action: 'back_end_errors',
                        label: `inactivity-warning-msg_close_cta_pag:dpflres`,
                    },
                    closeIcon: {
                        action: 'back_end_errors',
                        label: `inactivity-warning-msg_close_x_pag:dpflres`,
                    },
                    show: {
                        action: 'back_end_errors',
                        label: 'inactivity-warning-msg_onload_pag:dpflres',
                    },
                },
            };
        } else {
            response = {
                template: '.session_about_to_expire_alert_hurry',
                translations: pluralizeSteps(setSessionAboutToExpire10MinImprovements(translations.old)),
                actions: ['close'],
            };
        }

        if ( isMobile() && Odigeo.AB.isCssVariationMobile ) {
            response.template = '.session_about_to_expire_alert_cobaltui';
            response.translations = pluralizeSteps(setSessionAboutToExpire10MinImprovements(translations.old));
            response.actions = ['close'];
        }

        return response;
    };

    const setSessionAboutToExpire10MinWarningMobile = function(translations) {
        translations.headerToShow = translations.headerToShowNewContent10MinWarningMobile;
        translations.contentToShow = translations.contentToShowNewContent10MinWarningMobile;
        return translations;
    };

    const setSessionAboutToExpire10MinImprovements = function(translations) {
        translations.headerToShow = translations.hurry;
        return translations;
    };

    const setSessionAboutToExpireAlertForFlexibility = function(translations) {
        if (Odigeo.Utils.parseJson(Odigeo.Session.get('isFlexibilityDisruptionWaitingActive'))) {
            translations.headerToShow = translations.headerToShowFlexibilityDisruption;
            translations.contentToShow = translations.contentToShowFlexibilityDisruption;
        }
        return translations;
    };

    var sessionAboutToExpireAlertContent = function(config) {
        var translations = config.translations;
        return {
            ...translations,
            header: translations.headerToShow,
            content: translations.contentToShow,
            footer: translations.footer,
            close: translations.close,
            footerInfo: getPhoneInfo(translations),
            phone: getPhoneString(translations),
            seatsInfo: getSeatsString(translations),
        };
    };

    var isMobile = function() {
        return Odigeo.SessionScope.flow === 'mobile';
    };

    var showContentVariation = function() {
        return !Odigeo._.contains(
            ['results', 'dpresults_accommodation', 'dpresults_flights', 'dpresults_accommodation_details', 'xsellproductselection'],
            Odigeo.History.getPageNameFromFragment()
        );
    };

    var pluralizeSteps = function(key) {
        var page = Odigeo.History.getPageNameFromFragment();
        var steps = page === 'payment' ? 1 : 2;
        return Odigeo.Utils.pluralizeAll(key, steps);
    };

    var getPaxString = function(paxSelected, translations) {
        var paxUnion = [', ', ' ' + translations.and + ' '];
        var paxVals = Odigeo._.chain(paxSelected).map(function(val) {
            if (val.number === 0) {
                return false;
            }
            return Odigeo.Utils.pluralizeAll(val.key, val.number);
        }).compact().value();
        return (paxVals.length > 1 ? Odigeo._.initial(paxVals).join(paxUnion[0]) + paxUnion[1] : '') + Odigeo._.last(paxVals);
    };

    var getSeatsString = function(translations) {
        var nSeats = parseInt(translations.seatsLeft, 10) || 0;
        return showContentVariation() && nSeats > 0 ? Odigeo.Utils.pluralizeAll(translations.seatsToShow, nSeats) : '';
    };

    var getPhoneString = function(translations) {
        return isMobile() ? '<a class="dialog_phone_btn" href="tel:' + translations.phoneHref + '">' +
            translations.phone + '</a>' : translations.phone;
    };

    var getPhoneInfo = function(translations) {
        return translations.hours + ' ' + translations.charge;
    };

    var convertDate = function(date, dateFormat) {
        return Odigeo.Utils.formatDate(Odigeo.Utils.parseDate(date), dateFormat, true);
    };

    var getSeparateStay = function(data, translations) {
        var hotelInfo = '';
        if (data.checkInDate && data.checkOutDate &&
        (data.searchSegments[0].dateStr !== data.checkInDate ||
            data.searchSegments[1].dateStr !== data.checkOutDate)) {
            hotelInfo ='<div class="od-expire-call-us-flights odf-text-md">' +
                '<span class="odf-strong">' + translations.hotelTitle + ': </span>' +
                convertDate(data.checkInDate, translations.dateFormat) + '-' +
                convertDate(data.checkOutDate, translations.dateFormat) + '</div>';
        }
        return hotelInfo;
    };
}());
